import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

const cardVariants = cva(
  [
    "rounded-2xl transition-all duration-300 ease-out",
    "motion-reduce:transition-none",
  ].join(" "),
  {
    variants: {
      variant: {
        default:
          "bg-white border-sands-200 border-2 hover:shadow-lg",
        muted: "bg-sands-100 border-sands-200 border-2",
        semantic: "bg-card border border-border shadow-sm",
        glass: "bg-white/80 backdrop-blur-sm border border-sands-200",
      },
      padding: {
        none: "",
        sm: "p-4",
        default: "p-8",
        lg: "p-10",
      },
    },
    defaultVariants: {
      variant: "default",
      padding: "default",
    },
  },
);

export interface CardProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cardVariants> {}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant, padding, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(cardVariants({ variant, padding }), className)}
      {...props}
    />
  ),
);
Card.displayName = "Card";

export { cardVariants };
